export default "__VITE_ASSET__CH$Ea9zt__"